export const STEPS = {
    FIRST_STEP: '0',
    SECOND_STEP: '1',
};
export default STEPS;
